import { render, staticRenderFns } from "./KusBaseMessage.vue?vue&type=template&id=31a4eba7"
import script from "./KusBaseMessage.vue?vue&type=script&lang=js"
export * from "./KusBaseMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports